"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const Transactions = new Map();
const Spans = new Map();
let fetchInterceptor = false;
let Sentry;
let sentryInitialised;
const init = (sentryInstance, options) => {
    sentryInitialised = true;
    Sentry = sentryInstance;
    fetchInterceptor = options.addFetchInterceptor;
    const fetch = window.fetch;
    window.fetch = (...args) => ((args) => __awaiter(void 0, void 0, void 0, function* () {
        if (!fetchInterceptor) {
            return yield fetch(...args);
        }
        const spanArray = [...Transactions.values()].map(t => t.startChild({ op: 'http', description: args[0] }));
        const result = yield fetch(...args);
        if (spanArray.length > 0) {
            spanArray.forEach(span => {
                span.setTag('http.status_code', result.status);
                span.finish();
            });
        }
        return result;
    }))(args);
};
const startLog = (eventName, logData, ignoreTx = false) => {
    if (!sentryInitialised) {
        return;
    }
    if (ignoreTx === true) {
        Transactions.get(eventName).sampled = false; //navigating within the theme does a lot of logging for nothing, since nothing is loading and it is intant. this is a quick hack to stop that. ideally the loading of the theme is refactored and the logic moved out of the components.
    }
    console.time(eventName);
    Transactions.set(eventName, Sentry.startTransaction({ name: eventName, data: logData }));
};
const endLog = (eventName) => {
    if (!sentryInitialised) {
        return;
    }
    const transaction = Transactions.get(eventName);
    if (transaction) {
        console.timeEnd(eventName);
        transaction.finish();
        Transactions.delete(eventName);
    }
};
const startSpan = (eventName, spanName, spanData) => {
    if (!sentryInitialised) {
        return;
    }
    const trans = Transactions.get(eventName);
    if (trans) {
        const span = trans.startChild(spanData);
        Spans.set(spanName, span);
        return span;
    }
};
const endSpan = (spanName) => {
    if (!sentryInitialised) {
        return;
    }
    const span = Spans.get(spanName);
    if (span) {
        span.finish();
        Spans.delete(spanName);
    }
};
module.exports = {
    init,
    startLog,
    endLog,
    startSpan,
    endSpan
};
//# sourceMappingURL=index.js.map


// WEBPACK FOOTER //
// ./node_modules/@kathondvla/kovsentry/dist/index.js